import { HTMLAttributes } from 'react';
import { OneOrMoreReactElements } from '../../types';
import { joinClassNames } from '../../utils';
import { ButtonProps } from './Button';
import { ButtonSize } from './enums';
import styles from './styles.module.scss';

export type ButtonGroupProps = HTMLAttributes<HTMLDivElement> & {
  children: OneOrMoreReactElements<ButtonProps>;
  fullWidth?: boolean;
  size?: ButtonSize;
};

const getClassForSize = (size: ButtonSize) => `buttonGroup--${size}` as keyof typeof styles;

export const ButtonGroup = ({
  children,
  fullWidth = false,
  size = ButtonSize.Medium,
  className,
  ...props
}: ButtonGroupProps) => (
  <div
    role="group"
    className={joinClassNames(
      styles.buttonGroup,
      styles[getClassForSize(size)],
      fullWidth && styles.fullWidth,
      className
    )}
    {...props}
  >
    {children}
  </div>
);

ButtonGroup.displayName = 'ButtonGroup';
